import { getUrl } from "@aws-amplify/storage";

export const getInvoiceFile = async (key, grpUserId, hostelId) => {
  if (!key || key.trim() === "") {
    return null;
  }

  // If it's a googleusercontent link → return directly
  if (key.includes("googleusercontent")) {
    return key;
  }

  try {
    let path;

    // 🧾 Special case: Invoice files always inside public/guest_invoice
    if (key.startsWith("guest_invoice/")) {
      path = key; // ✅ Do NOT add "public/" manually
    }
    // 🖼️ New image format
    else if (key.startsWith("image-")) {
      const extractModulePath = (key) => {
        try {
          const parts = key.split("-");
          const length = parts.length;
          const module = parts[length - 4];
          const year = parts[length - 3];
          const monthName = parts[length - 2];
          const day = parts[length - 1];
          return `${module}/${year}/${monthName}/${day}/${key}`;
        } catch (e) {
          console.error("Error extracting module path:", e);
          return key;
        }
      };

      path = `${encodeURIComponent(grpUserId)}/${hostelId}/${extractModulePath(
        key
      )}`;
    }
    // 📂 Old format
    else {
      path = `${encodeURIComponent(grpUserId)}/${key}`;
    }

    console.log("Resolved S3 Path:", path);

    // Generate signed URL using Amplify
    const result = await getUrl({
      key: path,
      options: {
        accessLevel: "public", // public files (same as your bucket structure)
        expires: 604800, // 7 days
        useAccelerateEndpoint: true,
      },
    });

    return result.url;
  } catch (error) {
    console.error("Error getting file:", error);
    return null;
  }
};
